<app-navbar></app-navbar>
    <div class="breadcrumb">
       <a href="/">YouPrice</a>  &rarr; 
        <strong *ngIf="operateur == 'orange'">Forfaits mobiles réseau Orange</strong>
        <strong *ngIf="operateur == 'sfr'">Forfaits mobiles réseau SFR</strong>
        <strong *ngIf="operateur == 'bouygues'">Forfaits mobiles réseau Bouygues Télécom</strong>
    </div>

    <main>
        <h1 class="page-title" *ngIf="operateur != 'bouygues'">Forfaits mobiles réseau <span class="{{operateur}}">{{operateur.toUpperCase()}}</span></h1>
        <h1 class="page-title" *ngIf="operateur == 'bouygues'">Forfaits mobiles réseau <span  class="{{operateur}}">BOUYGUES TÉLÉCOM</span></h1>

        <section class="pricing-section {{operateur}}">
            <h2 class="section-title {{operateur}}">Forfaits sans engagement</h2>
            
            <div class="cards-grid" [style.--desktop-columns]="products.length || 1">
                <div class="card" *ngFor="let forfait of products" (click)="goToOffer(forfait.operateur, forfait.urlName,products)">
                    <div class="badge-container">
                        <span class="badge bg-{{operateur}}" *ngIf="forfait.inclus5G">5G</span>
                        <span class="badge outline-{{operateur}}" *ngIf="!forfait.inclus5G">4G</span>
                        <span *ngIf="forfait.simPrice === 1" class="sim-badge {{operateur}}">
                            <span class="sim-badge-icon" aria-hidden="true"></span>
                            <span>SIM<br>à 1€</span>
                        </span>
                    </div>
                    <div class="data-amount">{{ forfait.maxVolume }} GO</div>
                    <div class="price {{operateur}}">{{ forfait.maxTarif }}€<p>/mois</p></div>
                    
                    <div class="features">
                        <div class="feature-row">
                            <span>Go EU & DOM</span>
                            <strong>{{(forfait.forfaitRoamingEuropVolume/(1024*1024*1024))}}Go</strong>
                        </div>
                        <div class="feature-row">
                            <span>Appels/SMS/MMS</span>
                            <strong>Illimités</strong>
                        </div>
                    </div>
                    
                    <button class="btn-commander" (click)="createBasket(forfait); $event.stopPropagation(); $event.preventDefault()">Commander</button>
                    <a  [routerLink]="['/forfaits-mobile-'+forfait.operateur, forfait.urlName]" (click)="$event.stopPropagation()" class="link-voir">&rarr; Voir l'offre</a>
                </div>

           

            </div>
        </section>

        <aside class="bottom-links" *ngIf="operateur == 'orange'">
            <a href="/forfaits-mobile-sfr/">&rarr; Toutes les offres sur le réseau SFR</a>
            <a href="/forfaits-mobile-bouygues/">&rarr; Toutes les offres sur le réseau Bouygues Télécom</a>
        </aside>
        <aside class="bottom-links" *ngIf="operateur == 'sfr'">
            <a href="/forfaits-mobile-orange/">&rarr; Toutes les offres sur le réseau Orange</a>
            <a href="/forfaits-mobile-bouygues/">&rarr; Toutes les offres sur le réseau Bouygues Télécom</a>
        </aside>
        <aside class="bottom-links" *ngIf="operateur == 'bouygues'">
            <a href="/forfaits-mobile-orange/">&rarr; Toutes les offres sur le réseau Orange</a>
            <a href="/forfaits-mobile-sfr/">&rarr; Toutes les offres sur le réseau SFR</a>
        </aside>

    </main>

<app-always-there></app-always-there>
<app-small-faq></app-small-faq>
<app-interest-you></app-interest-you>
<app-footer></app-footer>